export default __webpack_public_path__ + "static/yellow-logo-3adbc27af5957f75728116d18d09c654.svg";